import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { onsNotification } from 'ngx-onsenui'
import { AuthService } from '../../../../services/auth.services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { RestServices } from '../../../../services/rest.services'
import { SharedServices } from '../../../../services/shared.services'
import * as moment from 'moment'
import { ClientTopServices } from '../../../../services/ClientTop.services'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { StateServices } from '../../../../services/state.services'
import Constants from '../../../../commons/Constants'
import { DatepickerHelper } from '../../../../../helper/datepicker.helper'
import { isNullOrUndefined, mongoObjectId } from '../../../../../helper'

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: [
        './profile.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/lui-select.component.css',
    ],
})
export class ProfileComponent implements OnInit, OnDestroy, AfterViewInit {

    formNewClient: FormGroup
    listClinic: any
    listDoctor: any
    listCordinator: any
    arrayGender = Constants.ARRAY_GENDER
    arrayUseTreatment = [...Constants.ARRAY_USE_TREATMENT]
    arrayDevice = Constants.ACCELEDENT_DEVICES
    arrayPublication = Constants.ARRAY_PUBLICATION_APPROVED
    arrayAligner = Constants.ARRAY_ALIGNER_MAIL
    urls: any[] = []
    displayRemoveUrl = true
    list: any
    doctorName: string = ''
    doctorNameDeleted
    cordinatorName: string = ''
    cordinatorNameDeleted
    errorTextEmail1: string = 'Invalid mail format'
    errorTextEmail2: string = 'Invalid mail format'
    validEmail1 = false
    validEmail2 = false
    statusCheck
    clinicSelected = ''
    doctorSelected = ''
    cordinatorSelected = ''
    genderSelected
    useTreatmentSelected
    accelationSelected
    alignerMailSelected
    publicationSelected
    listUrl: any[] = []
    dateBirthday: any
    optionsBirthday: any = {
        viewMode: 'years',
        ...DatepickerHelper.BASE_NONE_TODAY_OPTIONS,
    }
    dateStart: any
    dateLast: any
    dateAccountStart: any
    optionsStartDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }
    showDateBirthday: string = 'Click to Select'
    showDateStart: string = 'Click to Select'
    showDateLast: string = 'Click to Select'
    showDateAccountStart: string = 'Click to Select'
    showAge: number = 0
    timestampBirthday: number
    timestampStart: number
    timestampLast: number
    timestampAccountDate: number
    en = {}
    showEN = true
    idClient
    clientDetail
    loadingCheck = false
    hasAppointMailSetting = false
    hasOptionalMailSetting = false
    listUrlId: any[] = []
    clientIdParam
    valueNameChange

    listOption2General: any[] = []
    jsonDataSave: any = {}

    listOptionFooter: any[] = []
    jsonChangeDataSave: any = {}

    saveData

    enableBehavior = 'false'

    header = 'header'
    footer = 'footer'

    isValidate = false
    isFamilyName = false
    isFirstName = false
    isCheck = false

    appointmentMailSetting
    optionalMailSetting

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private formBuilder: FormBuilder, private route: ActivatedRoute, private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices,
                private stateServices: StateServices) {
        _sharedService.changeEmittedSource$.subscribe(
            res => {
                this.enableBehavior = this.stateServices.returnEnableBehavior()
                const emitLoading = {}
                emitLoading['first'] = false
                this.stateServices.emitChangeFirstLoading(emitLoading)
                this.stateServices.emitChangeArrImageHash(null)
                this.list = res
                if (Array.isArray(res)) {
                    let resultTest3 = res.find(staff => staff.role === 'doctor')
                    let resultTest4 = res.find(staff => staff.role === 'cordinator')
                    if (resultTest3) {
                        let resultTest = this.listDoctor.find(staff => staff._id === resultTest3.id)
                        this.doctorName = (resultTest.firstName || '') + ' ' + (resultTest.familyName || '')
                        this.doctorNameDeleted = resultTest.deleted
                        if (resultTest) {
                            this.doctorSelected = resultTest._id
                            this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
                        } else {
                            this.doctorSelected = null
                        }
                    }
                    if (resultTest4) {
                        let resultTest2 = this.listCordinator.find(staff => staff._id === resultTest4.id)
                        this.cordinatorName = (resultTest2.firstName || '') + ' ' + (resultTest2.familyName || '')
                        this.cordinatorNameDeleted = resultTest2.deleted
                        if (resultTest2) {
                            this.cordinatorSelected = resultTest2._id
                            this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
                        } else {
                            this.cordinatorSelected = null
                        }
                    }
                }
            })
    }

    ngOnInit() {
        this.stateServices.emitChangeHash(null)
        this.matrixServices.resetMatrix()
        this.stateServices.emitChangeViewAligner('renderData')
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.stateServices.emitChangeArrImageHash(null)
        this.jsonChangeDataSave = {}
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idClient = id
            this.clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
        })
        this.formNewClient = this.formBuilder.group({
            clientNumber: '',
            familyName: [' ', [Validators.required]],
            firstName: [' ', [Validators.required]],
            familyNameKana: '',
            firstNameKana: '',
            birthDay: '',
            phoneNumber1: '',
            phoneNumber2: '',
            address1: '',
            address2: '',
            email1: ['', [Validators.email]],
            email2: ['', [Validators.email]],
            startDate: '',
            lastDate: '',
            accountDate: '',
            presentationName: '',
            case: '',
            billName: '',
            urls: this.formBuilder.array([this.createItemUrl()]),
        })
        this.callApi()
        this.mainClient()
        this.urls = this.formNewClient.get('urls')['controls']
        this.functionSaveData()
    }

    ngOnDestroy() {
        if(this.saveData)
            this.saveData.unsubscribe()
    }

    functionSaveData() {
        this.saveData = this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success && success[0] === 'saveNewClient' && success[1] == 'profile') {
                    this.submitFormNewClient()
                }
            },
        )
    }

    get constantsConst() {
        return Constants
    }

    functionEmitJsonSave(jsonSave: any) {
        this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
        this.jsonChangeDataSave = jsonSave
    }

    callApi() {
        // this.matrixServices.arrRotate = [];
        // this.matrixServices.arrStyleImage = [];
        // this.matrixServices.arrFlip = [];
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const map: any = {}
        map[this.idClient] = true

        const status = {
            client: {
                map: map,
            },
            clientAligner: {
                paths: clientVisit,
                searches: clientVisit,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                    appointMail: true,
                    optionalMail: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        const resourceData = {
            actions: [],
            status: status,
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                const user = success['user']
                this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                const emitSakura = {}
                emitSakura['enableBehavior'] = this.enableBehavior
                this.stateServices.emitChangeEnableBehavior(emitSakura)
                const option2GeneralAll: any[] = success['response'] ? success['response']['setting']['paths']['{}'] : []
                this.appointmentMailSetting = success['response']['setting']['map']['appointMail']
                this.optionalMailSetting = success['response']['setting']['map']['optionalMail']
                this.hasAppointMailSetting = !!success['response']['setting']['map']['appointMail']
                this.hasOptionalMailSetting = !!success['response']['setting']['map']['optionalMail']
                this.jsonDataSave = success['response']['client']['map'][this.idClient] ? success['response']['client']['map'][this.idClient] : {}
                if (option2GeneralAll && option2GeneralAll.length > 0) {
                    const arraySettingOption = option2GeneralAll.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (arraySettingOption) {
                        if (this.enableBehavior == 'true') {
                            this.listOption2General = (arraySettingOption['clientProfileFormHeader'] && arraySettingOption['clientProfileFormHeader']['properties']) ? arraySettingOption['clientProfileFormHeader']['properties'] : []
                        } else {
                            this.listOption2General = []
                        }
                    } else {
                        this.listOption2General = []
                    }
                    this.jsonChangeDataSave = {}
                    const fakeFooterByHeader: any[] = []
                    this.listOption2General.forEach(el => {
                        const jsonFake = {}
                        fakeFooterByHeader.push(jsonFake)
                    })
                    let listFooter: any[] = []
                    if (arraySettingOption) {
                        if (this.enableBehavior == 'true') {
                            listFooter = (arraySettingOption['clientProfileFormFooter'] && arraySettingOption['clientProfileFormFooter']['properties']) ? arraySettingOption['clientProfileFormFooter']['properties'] : []
                        } else {
                            listFooter = []
                        }
                    }
                    this.listOptionFooter = fakeFooterByHeader.concat(listFooter)
                }
            })
        })
    }

    preSubmit() {
        this.isCheck = false;
        let familyName = this.formNewClient.get('familyName').value;
        let firstName = this.formNewClient.get('firstName').value;
        this.validatorEmail('email1', this.formNewClient.get('email1').value)
        this.validatorEmail('email2', this.formNewClient.get('email2').value)
        if (familyName.trim() === '' || firstName.trim() === '' || this.validEmail1 === true || this.validEmail2 === true) {
            this.isValidate = true;
            this._sharedService.emitChange('valid-profile')
        } else {
            this.isValidate = false;
            this._sharedService.emitChange('unvalid-profile')
        }
        this.isCheck = true
        if (familyName.trim() !== '') {
            this.isFamilyName = false
        } else {
            this.isFamilyName = true
        }
        if (firstName.trim() !== '') {
            this.isFirstName = false
        } else {
            this.isFirstName = true
        } 
        this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
    }

    checkAgain() {
        let familyName = this.formNewClient.get('familyName').value;
        let firstName = this.formNewClient.get('firstName').value;
        if (familyName.trim() === '' || firstName.trim() === '' || this.validEmail1 === true || this.validEmail2 === true) {
            this.isValidate = true;
            this._sharedService.emitChange('valid-profile')
        } else {
            this.isValidate = false;
            this._sharedService.emitChange('unvalid-profile')
        }
    }

    confirmSubmit() {
        if (this.isValidate) {
            onsNotification.confirm({
                message: this.en['alert-validate'],
                title: this.en['alert-title'],
                cancelable: true,
                buttonLabels: this.en['alert-cancel'],
                modifier: 'rowfooter',
            })
        } else {
            onsNotification.confirm({
                message: this.en['client-detail-profile-confirm-submit-message'],
                title: '<b>' + this.en['client-detail-profile-confirm-submit-title'] + '</b>',
                buttonLabels: [this.en['client-detail-profile-confirm-submit-lable-cancel'], this.en['client-detail-profile-confirm-submit-lable-ok']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.submitFormNewClient()
                        const profileSave: any = {}
                        profileSave['save'] = true
                        this.stateServices.emitChangeProfileSave(profileSave)
                    }
                },
            })
        }
    }

    submitFormNewClient() {
        for (let i = 0; i < this.urls.length; i++) {
            let url = this.urls[i]
            if (this.listUrlId[i]) {
                this.listUrl.push({ _id: this.listUrlId[i], title: url.value.urlName, url: url.value.url })
            } else {
                this.listUrl.push({ _id: mongoObjectId(), title: url.value.urlName, url: url.value.url })
            }
        }
        let resultListClinic = this.listClinic.find(option => option.action === true)
        let resultListGender = this.arrayGender.find(option => option.action === true)
        let resultListUseTreatment = this.arrayUseTreatment.find(option => option.action === true)
        let resultListAccelation = this.arrayDevice.find(option => option.action === true)
        let resultListAligner = this.arrayAligner.find(option => option.action === true)
        let resultListPublicationOK = this.arrayPublication.find(option => option.action === true && option.name === 'OK')
        let resultListPublicationNG = this.arrayPublication.find(option => option.action === true && option.name === 'NG')
        if (resultListClinic) {
            this.clinicSelected = resultListClinic._id
        } else {
            this.clinicSelected = null
        }
        if (resultListGender) {
            this.genderSelected = resultListGender.value
        } else {
            this.genderSelected = null
        }
        if (resultListUseTreatment) {
            this.useTreatmentSelected = resultListUseTreatment.value
        } else {
            this.useTreatmentSelected = null
        }
        if (resultListAccelation) {
            this.accelationSelected = resultListAccelation.value
        } else {
            this.accelationSelected = null
        }
        if (resultListAligner) {
            this.alignerMailSelected = resultListAligner.value
        } else {
            this.alignerMailSelected = null
        }
        if (resultListPublicationOK) {
            this.publicationSelected = true
        } else if (resultListPublicationNG) {
            this.publicationSelected = false
        } else {
            this.publicationSelected = null
        }
        // if (this.formNewClient.get('firstName').valid && this.formNewClient.get('familyName').valid && this.validEmail1 == false && this.validEmail2 == false) {

        const dataSave: any = {
            accelationDevice: this.accelationSelected,
            address1: this.formNewClient.get('address1').value,
            address2: this.formNewClient.get('address2').value,
            case: this.formNewClient.get('case').value,
            clientNumber: this.formNewClient.get('clientNumber').value,
            clinic: this.clinicSelected,
            cordinator: this.cordinatorSelected,
            doctor: this.doctorSelected,
            email1: this.formNewClient.get('email1').value,
            email2: this.formNewClient.get('email2').value,
            enableAlignerMail: this.alignerMailSelected,
            familyName: this.formNewClient.get('familyName').value,
            familyNameKana: this.formNewClient.get('familyNameKana').value,
            firstName: this.formNewClient.get('firstName').value,
            firstNameKana: this.formNewClient.get('firstNameKana').value,
            gender: this.genderSelected,
            useTreatmentMenu: this.useTreatmentSelected,
            phone1: this.formNewClient.get('phoneNumber1').value,
            phone2: this.formNewClient.get('phoneNumber2').value,
            presentationName: this.formNewClient.get('presentationName').value,
            publicationApproved: this.publicationSelected,
            relatedUrls: this.listUrl,
            searchName: this.formNewClient.get('firstName').value + this.formNewClient.get('familyName').value + this.formNewClient.get('firstName').value,
            searchNameKana: this.formNewClient.get('firstNameKana').value + this.formNewClient.get('familyNameKana').value + this.formNewClient.get('firstNameKana').value,
            searchPhone1: this.formNewClient.get('phoneNumber1').value,
            searchPhone2: this.formNewClient.get('phoneNumber2').value,
            birthday: this.timestampBirthday,
            lastDate: this.timestampLast,
            startDate: this.timestampStart,
            accountDate: this.timestampAccountDate,
            billName: this.formNewClient.get('billName').value,
        }
        const listKeys: any[] = Object.keys(this.jsonChangeDataSave)
        listKeys.forEach(key => {
            dataSave[key] = this.jsonChangeDataSave[key]
        })
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: dataSave,
                },
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        const emit: any = {}
        emit['active'] = true
        this.clientTopServices.emitChangeActiveIndex(emit)
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChange('setRoutes')
                        this.loadingCheck = false
                        this.clientDetail = null
                        this.listUrlId = []
                        this.listUrl = []
                        this.urls = []
                        //
                        //
                        //
                        if (success['response']['client']['map'][this.idClient]['familyName'] && success['response']['client']['map'][this.idClient]['firstName']) {
                            this.valueNameChange = success['response']['client']['map'][this.idClient]['familyName'] + ' ' + success['response']['client']['map'][this.idClient]['firstName']
                        } else {
                            this.valueNameChange = success['response']['client']['map'][this.idClient]['firstName']
                        }
                        const nameChange = ['nameChange-ProfileComponent', this.valueNameChange]
                        const prevenName: any = success['response']['client']['map'][this.idClient]['presentationName']
                        this._sharedService.emitChange(nameChange)
                        const emitPre: any = {}
                        emitPre['name'] = prevenName
                        this.clientTopServices.emitChangePreventationName(emitPre)
                        // this.mainClient();
                        // this.router.navigate(['/app/main/client/edit/'+success['response'].client.updatedItem+'/profile']);
                    }
                },
            )
        })
        // }
        // else {
        //
        // }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    mainClient() {
        //
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                client: {
                    map: { [this.idClient]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.listDoctor = success['response']['staff']['paths']['{"roles":"doctor"}']
                    this.listCordinator = success['response']['staff']['paths']['{"roles":"cordinator"}']
                    this.listClinic = success['response']['clinic']['paths']['{}']
                    this.clientDetail = success['response']['client']['map'][this.idClient]
                    // Fill Data
                    this.formNewClient.get('clientNumber').setValue(this.clientDetail.clientNumber)
                    this.formNewClient.get('familyName').setValue(this.clientDetail.familyName)
                    this.formNewClient.get('firstName').setValue(this.clientDetail.firstName)
                    this.formNewClient.get('familyNameKana').setValue(this.clientDetail.familyNameKana)
                    this.formNewClient.get('firstNameKana').setValue(this.clientDetail.firstNameKana)
                    this.formNewClient.get('address1').setValue(this.clientDetail.address1)
                    this.formNewClient.get('address2').setValue(this.clientDetail.address2)
                    this.formNewClient.get('phoneNumber1').setValue(this.clientDetail.phone1)
                    this.formNewClient.get('phoneNumber2').setValue(this.clientDetail.phone2)
                    this.formNewClient.get('email1').setValue(this.clientDetail.email1)
                    this.formNewClient.get('email2').setValue(this.clientDetail.email2)
                    this.formNewClient.get('presentationName').setValue(this.clientDetail.presentationName)
                    this.formNewClient.get('case').setValue(this.clientDetail.case)
                    this.formNewClient.get('billName').setValue(this.clientDetail.billName)
                    // button radio
                    for (let i = 0; i < this.arrayGender.length; i++) {
                        let gender: any = this.arrayGender[i]
                        this.arrayGender[i].action = gender.value === this.clientDetail.gender
                    }

                    if (!isNullOrUndefined(this.clientDetail.useTreatmentMenu)) {
                        for (let i = 0; i < this.arrayUseTreatment.length; i++) {
                            let useTreatment: any = this.arrayUseTreatment[i]
                            this.arrayUseTreatment[i].action = useTreatment.value === this.clientDetail.useTreatmentMenu
                        }
                    } else {
                        this.selectDefaultTreatementUse()
                    }
                    this.setNoneAcceledent()
                    for (let i = 0; i < this.arrayDevice.length; i++) {
                        let device = this.arrayDevice[i]
                        if (device.value === this.clientDetail.accelationDevice) {
                            this.arrayDevice[i].action = true
                            break
                        }
                    }
                    for (let i = 0; i < this.arrayPublication.length; i++) {
                        let publication: any = this.arrayPublication[i]
                        this.arrayPublication[i].action = publication.action === this.clientDetail.publicationApproved
                    }
                    for (let i = 0; i < this.arrayAligner.length; i++) {
                        let aligner: any = this.arrayAligner[i]
                        this.arrayAligner[i].action = aligner.value === this.clientDetail.enableAlignerMail
                    }
                    for (let i = 0; i < this.listClinic.length; i++) {
                        let option = this.listClinic[i]
                        if (option._id == this.clientDetail.clinic) {
                            this.listClinic[i].action = true
                        } else {
                            this.listClinic[i].action = false
                        }
                    }
                    //modal selected
                    if (this.clientDetail.doctor) {
                        let resultTest = this.listDoctor.find(staff => staff._id === this.clientDetail.doctor)
                        if (resultTest) {
                            this.doctorName = (resultTest.firstName || '') + ' ' + (resultTest.familyName || '')
                            this.doctorSelected = resultTest._id
                            this.doctorNameDeleted = resultTest.deleted
                        } else {
                            this.doctorSelected = null
                            this.doctorNameDeleted = undefined
                        }
                    }
                    if (this.clientDetail.cordinator) {
                        let resultTest = this.listCordinator.find(staff => staff._id === this.clientDetail.cordinator)
                        if (resultTest) {
                            this.cordinatorName = (resultTest.firstName || '') + ' ' + (resultTest.familyName || '')
                            this.cordinatorNameDeleted = resultTest.deleted
                            this.cordinatorSelected = resultTest._id
                        } else {
                            this.cordinatorName = null
                            this.cordinatorNameDeleted = undefined
                        }
                    }
                    // datepicker
                    let offsetTimezone = new Date().getTimezoneOffset()
                    let addTime = 24 + (offsetTimezone / 60)
                    if (this.clientDetail.birthday) {
                        const timestamp = moment(this.clientDetail.birthday)
                        timestamp.set({ hours: 10 })
                        this.showDateBirthday = moment(timestamp).format('YYYY.MM.DD ddd')
                        this.timestampBirthday = this.clientDetail.birthday
                        this.showAge = moment().startOf('day').diff(moment(this.timestampBirthday).add(addTime, 'hours'), 'years')
                        this.dateBirthday = moment(timestamp)
                    }
                    if (this.clientDetail.startDate) {
                        // this.timestampStart = moment(this.clientDetail.startDate).utc().startOf('day').valueOf();
                        // this.showDateStart = moment(this.timestampStart).format('YYYY.MM.DD ddd');
                        // this.dateStart = moment(this.timestampStart).add(addTime, 'hours');
                        let adDate = moment(this.clientDetail.startDate)
                        let timestampDate = moment(adDate['_d']).utc().startOf('day').valueOf()
                        let event = {
                            '_d': timestampDate,
                            '_i': timestampDate,
                        }
                        this.updateDatepicker(event, 'start')
                    }
                    if (this.clientDetail.lastDate) {
                        // this.timestampLast = moment(this.clientDetail.lastDate).utc().startOf('day').valueOf();
                        // this.showDateLast = moment(this.timestampLast).format('YYYY.MM.DD ddd');
                        // this.dateLast = moment(this.timestampLast).add(addTime, 'hours');
                        let adDate = moment(this.clientDetail.lastDate)
                        let timestampDate = moment(adDate['_d']).utc().startOf('day').valueOf()
                        let event = {
                            '_d': timestampDate,
                            '_i': timestampDate,
                        }
                        this.updateDatepicker(event, 'last')
                    }

                    if (this.clientDetail.accountDate) {
                        let adDate = moment(this.clientDetail.accountDate)
                        let timestampDate = moment(adDate['_d']).utc().startOf('day').valueOf()
                        let event = {
                            '_d': timestampDate,
                            '_i': timestampDate,
                        }
                        this.updateDatepicker(event, 'account')
                    }

                    if (this.clientDetail.relatedUrls && this.clientDetail.relatedUrls[0]) {
                        this.formNewClient.get('urls')['controls'][0]['controls'].urlName.setValue(this.clientDetail.relatedUrls[0].title)
                        this.formNewClient.get('urls')['controls'][0]['controls'].url.setValue(this.clientDetail.relatedUrls[0].url)
                        this.listUrlId.push(this.clientDetail.relatedUrls[0]._id)
                    } else {
                        this.formNewClient.get('urls')['controls'][0]['controls'].urlName.setValue('')
                        this.formNewClient.get('urls')['controls'][0]['controls'].url.setValue('')
                    }
                    this.urls = this.formNewClient.get('urls')['controls']
                    this.displayRemoveUrl = false
                    //
                    //
                    //
                    //
                    if (Array.isArray(this.clientDetail.relatedUrls) && this.clientDetail.relatedUrls.length !== this.urls.length) {
                        for (let i = 1; i < this.clientDetail.relatedUrls.length; i++) {
                            let url = this.clientDetail.relatedUrls[i]
                            this.urls.push(this.createItemUrl(url.title, url.url))
                            this.listUrlId.push(url._id)
                        }
                    }
                },
            )
        })
    }

    checkAction(name, array, canDeactivate = true) {
        this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
        array.forEach(function(val) {
            if (val.name !== name) {
                val.action = false
            } else {
                if (val.action && canDeactivate) {
                    val.action = false
                } else {
                    val.action = true
                }
            }
        })
    }

    buttonSendMail(emailNumber) {
        let email = ''
        if (emailNumber === 'email1') {
            email = this.formNewClient.value.email1
        } else if (emailNumber === 'email2') {
            email = this.formNewClient.value.email2
        } else {
            email = 'unknow'
        }
        window.open('mailto:' + email + '?cc=&subject=&body=', '_blank')
    }

    buttonOpenUrl(url) {
        //
        window.open(url)
    }

    alertSendmail(option, typeMail) {
        let message, title
        switch (typeMail) {
            case Constants.MAIL_TYPE.APPOINT_MAIL: //appoint-mail
                message = this.en['client-detail-profile-confirm-appoint-mail-message']
                title = this.en['client-detail-profile-confirm-appoint-mail-title']
                break
            case Constants.MAIL_TYPE.OPTIONAL_MAIL: //optional-mail
                message = this.en['client-detail-profile-confirm-optional-mail-message']
                title = this.en['client-detail-profile-confirm-optional-mail-title']
                break
            default:
                message = this.en['client-detail-profile-confirm-test-mail-message']
                title = this.en['client-detail-profile-confirm-test-mail-title']
        }
        if ((option === 1 && this.clientDetail.email1 === this.formNewClient.get('email1').value && this.formNewClient.get('email1').value !== '')
            || (option === 2 && this.clientDetail.email2 === this.formNewClient.get('email2').value) && this.formNewClient.get('email2').value !== '') {
            if ((option === 1 && this.formNewClient.get('email1').value !== '')
                || (option === 2 && this.formNewClient.get('email2').value !== '')) {
                console.log('send mail')
                onsNotification.confirm(
                    {
                        message: message,
                        title: '<b>' + title + '</b>',
                        buttonLabels: [this.en['client-detail-profile-confirm-submit-lable-cancel'], this.en['client-detail-profile-confirm-submit-lable-ok']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 1) {
                                console.log('send mail')
                                // here this is not cancelled.  1 is correct.
                                switch (typeMail) {
                                    case Constants.MAIL_TYPE.APPOINT_MAIL: //appoint-mail
                                        this.sendMailAppoint(option)
                                        break
                                    case Constants.MAIL_TYPE.OPTIONAL_MAIL: //appoint-mail
                                        this.sendMailOptional(option)
                                        break
                                    default:
                                        this.sendMailTest(option)
                                        break
                                }
                            }
                        },
                    })
            }
        } else {
            onsNotification.alert(this.en['client-detail-profile-confirm-test-mail-alert-err'], { title: '<b>Error</b>' })
        }
    }

    openDoctorModal(option) {
        const arrayNewclient = ['activeModalDoctorProfile', option, this.listDoctor, this.listCordinator, this.doctorSelected, this.cordinatorSelected]
        this._sharedService.emitChange(arrayNewclient)
    }

    addUrl() {
        this.urls = this.formNewClient.get('urls')['controls']
        this.urls.push(this.createItemUrl())
        this.displayRemoveUrl = false
        //
    }

    removeUrl(index) {

        this.urls.splice(index, 1)
        if (index === 0 && this.urls.length < 1) {
            this.displayRemoveUrl = true
            this.urls.push(this.createItemUrl())
        }
        //
    }

    createItemUrl(urlName = '', url = ''): FormGroup {
        return this.formBuilder.group({
            urlName: urlName,
            url: url,
        })
    }

    sortUrl(index, action: string) {
        if (action === 'up') {
            let br1 = this.urls[index - 1]
            let br2 = this.urls[index]
            this.urls.splice(index - 1, 2, br2, br1)
            //
        } else if (action === 'down') {
            let br1 = this.urls[index]
            let br2 = this.urls[index + 1]
            this.urls.splice(index, 2, br2, br1)
            //
        } else {

        }
    }

    changeDisplayRemoveUrl() {
        this.displayRemoveUrl = false
    }

    validatorEmail(email, emailAddress) {
        const resourceUrl = 'form/checkMx'
        let domain = ''
        if (emailAddress.indexOf('@') !== -1) {
            domain = emailAddress.substr(emailAddress.indexOf('@') + 1, emailAddress.length - 1)
        }
        const resourceData = { host: domain }
        if (email === 'email1') {
            if (!this.formNewClient.get(email).valid && this.formNewClient.get(email).value != '') {
                this.validEmail1 = true
                this.errorTextEmail1 = 'Invalid mail format'
            } else if (this.formNewClient.get(email).valid) {

                this.restApi.http_post(resourceUrl, resourceData).subscribe(
                    res => {
                        this.statusCheck = res
                        if (this.statusCheck.status === 'notfound') {
                            this.validEmail1 = true
                            this.errorTextEmail1 = 'Mail server not exists (string after atmark may be wrong)'
                        } else {
                            this.validEmail1 = false
                        }
                        if (this.isCheck) 
                            this.checkAgain()
                    },
                )
            } else {
                this.validEmail1 = false
            }
        } else if (email === 'email2') {
            if (!this.formNewClient.get('email2').valid && this.formNewClient.get('email2').value != '') {
                this.validEmail2 = true
                this.errorTextEmail2 = 'Invalid mail format'
            } else if (this.formNewClient.get(email).valid) {


                this.restApi.http_post(resourceUrl, resourceData).subscribe(
                    res => {
                        this.statusCheck = res
                        if (this.statusCheck.status === 'notfound') {
                            this.validEmail2 = true
                            this.errorTextEmail2 = 'Mail server not exists (string after atmark may be wrong)'
                        } else {
                            this.validEmail2 = false
                        }
                        if (this.isCheck) 
                            this.checkAgain()
                    },
                )
            } else {
                this.validEmail2 = false
            }
        } else {

        }
    }

    updateDatepicker(event, option) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event && event['_d']) {
            if (this.loadingCheck) {
                this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
            }
            if (option == 'birthday') {
                const timestamp = moment(event['_d'])
                timestamp.set({ hours: 10 })
                this.timestampBirthday = moment(timestamp).utc().startOf('day').valueOf()
                this.showDateBirthday = moment(timestamp).format('YYYY.MM.DD ddd')
                this.showAge = moment().startOf('day').diff(moment(this.timestampBirthday).add(addTime, 'hours'), 'years')
                this.dateBirthday = moment(timestamp)
            } else if (option == 'start') {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampStart = moment().utc().startOf('day').valueOf()
                    this.showDateStart = moment().format('YYYY.MM.DD ddd')
                    this.dateStart = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampStart = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateStart = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateStart = moment(moment(timestamp).valueOf())
                }
            } else if (option == 'last') {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampLast = moment().utc().startOf('day').valueOf()
                    this.showDateLast = moment().format('YYYY.MM.DD ddd')
                    this.dateLast = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampLast = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateLast = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateLast = moment(moment(timestamp).valueOf())
                }
            } else {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampAccountDate = moment().utc().startOf('day').valueOf()
                    this.showDateAccountStart = moment().format('YYYY.MM.DD ddd')
                    this.dateAccountStart = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampAccountDate = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateAccountStart = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateAccountStart = moment(moment(timestamp).valueOf())
                }
            }
        }
    }

    nextDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else if (option == 'last') {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        } else {
            if (this.showDateAccountStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'account')
            }
        }
    }

    prevDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else if (option === 'last') {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        } else {
            if (this.showDateAccountStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'account')
            }
        }
    }

    private sendMailAppoint(mailNo) {
        if (this.hasAppointMailSetting) {
            console.log('Run sendMailAppoint')
            this.sendMailTest(mailNo, 'appoint')
        }
    }

    private sendMailOptional(mailNo) {
        if (this.hasOptionalMailSetting) {
            console.log('Run sendMailOptional')
            this.sendMailTest(mailNo, 'optional')
        }
    }

    private sendMailTest(mailNo, type = 'test') {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'clientMail',
                    type: 'create',
                    value: {
                        'clientId': this.idClient,
                        'data': {
                            'mailNo': mailNo,
                        },
                        'status': 'reserved',
                        'type': type,
                    },
                },
            ],
            status: {
                client: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                    }
                },
            )
        })
    }

    confirmRemove() {
        onsNotification.confirm(
            {
                message: this.en['client-detail-profile-confirm-remove-message'],
                title: '<b>' + this.en['client-detail-profile-confirm-remove-title'] + '</b>',
                buttonLabels: [this.en['client-detail-profile-confirm-submit-lable-cancel'], this.en['client-detail-profile-confirm-submit-lable-ok']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 1) {  // here this is not cancelled.  1 is correct.
                        this.removeClient()
                    }
                },
            })
    }

    removeClient() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'remove',
                },
            ],
            status: {
                client: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this.router.navigate(['/app/main/client/search'])
                    }
                },
            )
        })
    }

    checkDatepickerLoading() {
        this.loadingCheck = true
    }

    ngAfterViewInit(): void {

    }

    setNoneAcceledent() {
        this.arrayDevice.forEach(function(val) {
            val.action = false
        })
    }

    private selectDefaultTreatementUse() {
        // this.arrayUseTreatment = [...Constants.ARRAY_USE_TREATMENT];
        this.arrayUseTreatment.forEach(function(val, index) {
            val.action = index == 0
        })
    }

    openMailModal() {
        let listEmail = []
        if (this.formNewClient.get('email1').value) {
            listEmail.push(this.formNewClient.get('email1').value)
        }
        if (this.formNewClient.get('email2').value) {
            listEmail.push(this.formNewClient.get('email2').value)
        }
        const arrayNewclient = ['activeModalMailProfile', listEmail, this.idClient]
        this._sharedService.emitChange(arrayNewclient)
    }

    openMailProfileModal() {
        let listEmail = []
        if (this.formNewClient.get('email1').value) {
            listEmail.push(this.formNewClient.get('email1').value)
        }
        if (this.formNewClient.get('email2').value) {
            listEmail.push(this.formNewClient.get('email2').value)
        }
        const arrayNewclient = ['activeModalMailProfileNew', listEmail, this.idClient]
        this._sharedService.emitChange(arrayNewclient)
    }
    
    openAppointmentMailModal(emailType: 'email1' | 'email2') {
        let receiver = {
            mailNo: emailType === 'email1' ? 1 : 2,
            email: ''
        }
        if (this.formNewClient.get(emailType).value) {
            receiver.email = this.formNewClient.get(emailType).value
        }

        const appointmentMailSettingObj = {
            type: 'appoint',
            setting: this.appointmentMailSetting
        }

        const arrayNewclient = ['activeModalAppointmentMail', receiver, this.idClient, appointmentMailSettingObj]
        this._sharedService.emitChange(arrayNewclient)
    }

    openOptionalMailModal(emailType: 'email1' | 'email2') {
        let receiver = {
            mailNo: emailType === 'email1' ? 1 : 2,
            email: ''
        }
        if (this.formNewClient.get(emailType).value) {
            receiver.email = this.formNewClient.get(emailType).value
        }
        
        const optionalMailSettingObj = {
            type: 'optional',
            setting: this.optionalMailSetting
        }
        const arrayNewclient = ['activeModalOptionalMail', receiver, this.idClient, optionalMailSettingObj]
        this._sharedService.emitChange(arrayNewclient)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/profile/profile.component.ts